import { ChevronRightIcon, MailIcon } from "lucide-react";

import { logger } from "@/lib/logger";
import { useAuthStore } from "@/store/authStore";
export function FeedbackSection() {
  const user = useAuthStore(state => state.user);

  const handleEmailInquiry = () => {
    try {
      const userId = user?.id ?? "";
      window.location.href = `mailto:support@case-d.com?subject=TOBO 문의하기&body=${encodeURIComponent(userId ? `\n\n---\n유저 ID: ${userId}` : "")}`;
    } catch (error) {
      logger.error({ domain: "settings", message: "메일 앱 열기 실패", error });
      alert("기본 메일 앱을 열 수 없습니다. 메일 주소: support@case-d.com 으로 직접 문의해주세요.");
    }
  };

  return (
    <section>
      <div className="rounded-xl bg-card overflow-hidden">
        <SettingsRow icon={<MailIcon className="size-4" />} label="메일 문의" onClick={handleEmailInquiry} />
      </div>
    </section>
  );
}

function SettingsRow({ icon, label, onClick }: { icon: React.ReactNode; label: string; onClick: () => void }) {
  return (
    <button
      type="button"
      className="flex w-full items-center gap-3 p-4 text-sm font-medium text-foreground hover:bg-muted/50 transition-colors cursor-pointer"
      onClick={onClick}
    >
      <span className="text-muted-foreground">{icon}</span>
      {label}
      <ChevronRightIcon className="size-4 text-muted-foreground ml-auto" />
    </button>
  );
}
